module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }